// extracted by mini-css-extract-plugin
module.exports = {"posts":"travel-guide_posts__RPb8l","postPreview":"travel-guide_postPreview__6ZE4x"};